import { isChatbotRoutePath } from '~/features/chatbot/utils'
import { EClientPath, EMarketingClientPath } from '~/models/api'

type TPageMetadata = {
  title: string
  description: string
}
const getPageMetadata = (
  routePath: EClientPath | EMarketingClientPath,
  partnerName: string,
): TPageMetadata => {
  if (!partnerName) {
    return {
      title: 'Replify',
      description: 'Replify - Connect with your leads',
    }
  }

  const partialTextChunk = [partnerName]
  let customDescription = ''
  let titleSeparator = ' - '

  switch (routePath) {
    case EMarketingClientPath.home:
      partialTextChunk.push('AI Receptionist')
      break
    case EMarketingClientPath.examplePage:
      partialTextChunk.push('See an example')
      break
    case EMarketingClientPath.supportAndContact:
      partialTextChunk.push('Support')
      break
    case EMarketingClientPath.pricing:
      partialTextChunk.push('Pricing')
      break
    case EMarketingClientPath.faq:
      partialTextChunk.push('FAQ')
      break
    case EMarketingClientPath.referralsAbout:
      partialTextChunk.push('Referral program')
      break
    case EClientPath.overview:
      partialTextChunk.push('Account Overview')
      break
    case EClientPath.settingsBase:
      partialTextChunk.push('Account Settings')
      break
    case EClientPath.contacts:
      partialTextChunk.push('Account Contacts')
      break
    case EClientPath.reports:
      partialTextChunk.push('Account Reports')
      break
    case EClientPath.billing:
      partialTextChunk.push('Account Billing')
      break
    case EClientPath.referralsInfo:
      partialTextChunk.push('Account Referrals')
      break
    case EClientPath.login:
      titleSeparator = ' | '
      partialTextChunk.unshift('Login')
      customDescription = `Sign in to your ${partnerName} account to manage your AI sales and AI customer service agent(s), view conversations, and manage your account.`
      break
    default:
      if (isChatbotRoutePath(routePath)) {
        partialTextChunk.push('Chat')
      }
  }

  return {
    title: partialTextChunk.join(titleSeparator),
    description: customDescription || partialTextChunk.join(' - '),
  }
}

export default getPageMetadata
